// based off of https://github.com/noeldelgado/values.js
export default function hexToRgb(hex) {
  var bw = parseInt(hex.slice(1), 16);
  var red = bw >> 16 & 255;
  var green = bw >> 8 & 255;
  var blue = bw & 255;
  return [red, green, blue];
}